// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const getStaffPrefix = (type) => {
  switch (type) {
    case "State":
      return "ADM"; // Admin
    case "Division":
      return "DSP"; // DSP
    case "District":
      return "BSP"; // BSP
    case "Block":
      return "GM"; // General Manager
    case "Cluster":
      return "MM"; // Marketing Manager
    case "Franchise":
      return "SO"; // Sales Officer
    case "Village":
      return "FO"; // Field Officer
    default:
      return "STF"; // fallback
  }
};

export const getStaffId = (staffId) => `STF-${staffId}`;
